'use strict';
import * as $j_app$002edata$002e$002dUser$002dKind from "./app.data.-User-Kind.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_UserKind$Member(organizationId) {
  this.Ya = null;
  this.Ya = organizationId;
}
export { $c_Lapp_data_UserKind$Member as $c_Lapp_data_UserKind$Member };
$p = $c_Lapp_data_UserKind$Member.prototype = new $j_app$002edata$002e$002dUser$002dKind.$h_Lapp_data_UserKind();
$p.constructor = $c_Lapp_data_UserKind$Member;
/** @constructor */
function $h_Lapp_data_UserKind$Member() {
}
export { $h_Lapp_data_UserKind$Member as $h_Lapp_data_UserKind$Member };
$h_Lapp_data_UserKind$Member.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_UserKind$Member)) {
    var x = this.Ya;
    var x$2 = x$0.Ya;
    return ((x === null) ? (x$2 === null) : x.f(x$2));
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "Member";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.Ya;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "organizationId";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 1;
});
function $isArrayOf_Lapp_data_UserKind$Member(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k0)));
}
export { $isArrayOf_Lapp_data_UserKind$Member as $isArrayOf_Lapp_data_UserKind$Member };
var $d_Lapp_data_UserKind$Member = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_UserKind$Member, "app.data.UserKind$Member", ({
  k0: 1,
  fS: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_UserKind$Member as $d_Lapp_data_UserKind$Member };
//# sourceMappingURL=app.data.-User-Kind$-Member.js.map
